import { ElementRef, Injectable } from '@angular/core';
import get from 'lodash-es/get';

import { ParallaxBackgroundService } from '../parallax-background.service';
import { ParallaxThemeInterface } from './parallax-theme.inferface';

@Injectable()
export class DefaultTheme implements ParallaxThemeInterface {
    private backgroundLayer;

    constructor(private elementRef: ElementRef) {}

    setup(parallaxBgService: ParallaxBackgroundService) {
        const blockData = parallaxBgService.data;

        // We need to get a reference to each of the layers and add some default classes
        this.backgroundLayer = this.elementRef.nativeElement.querySelector('.layer-1');

        // Add some default classes
        this.backgroundLayer.classList.add('fixed-background', 'cover-background');

        // Get the static background
        const staticBg = get(blockData, 'static.srcGroup', [{srcSet: ''}])[0].srcSet;

        // Add a few styles to the head
        const css = `
            finder-parallax-background .fixed-background {
                background-image: url(${staticBg});
            }
        `;
        parallaxBgService.createStyle(css, 'default-theme');
    }

    /* istanbul ignore next */
    handleIntersection(ioEntry: IntersectionObserverEntry) {
        // This method is required but not needed for the default theme
        return;
    }
}
